import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Bell } from 'lucide-react';
import { NotificationCenter } from './NotificationCenter';
import { useUnreadCount } from '@/hooks/use-notifications';
import { cn } from '@/lib/utils';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 640 : false
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isMobile;
}

export function NotificationBell() {
  const [isOpen, setIsOpen] = useState(false);
  const { data: unreadCount } = useUnreadCount();
  const isMobile = useIsMobile();

  const count = unreadCount?.count || 0;
  const mode = isMobile ? 'drawer' : 'dropdown';

  const center = (
    <NotificationCenter
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      mode={mode}
    />
  );

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          'relative p-2 text-white/50 hover:text-white transition-colors',
          isOpen && 'text-white'
        )}
        aria-label="Notifications"
      >
        <Bell className="h-5 w-5" />
        {count > 0 && (
          <span className="absolute -top-1 -right-1 h-5 w-5 bg-red-500 text-white text-xs font-semibold rounded-full flex items-center justify-center">
            {count > 99 ? '99+' : count}
          </span>
        )}
      </button>

      {isOpen && (
        isMobile
          ? createPortal(center, document.body)
          : center
      )}
    </div>
  );
}
